import { pick } from '../helpers/parser/language-header.parser';

export const BundledLocales = ['en', 'de'];


const addMissingElements = <T>(arr1: T[], arr2: T[]): T[] => {
  // Convert arrays to sets for faster comparison
  let set1 = new Set(arr1);
  let set2 = new Set(arr2);

  // Find the elements in set1 that are missing in set2
  let missingElements = Array.from(set1).filter(elem => !set2.has(elem));

  // Add missing elements to arr2
  return arr2.concat(...missingElements);
}

/***
 * Check if the given language matches the bundled language. If matches will
 * return back the matched bundled language
 * @param {string} language language to verify
 * @returns {string | null} matching bundled language, else return null
 */
export const getBundledTranslation = (language: string): string | null => {
  return pick(BundledLocales, [language]);
}


/**
 * Add bundled languages if it's missing in supported languages.
 * If bundled language already exist it won't be added.
 *
 * @param languages the supported languages
 * @returns array of languages along with bundled language
 * */
export const addBundledLanguages = (languages: string[]): string[] => {
  return addMissingElements(BundledLocales, languages);
}
